import { render } from "./RestaurantOrderItem.vue?vue&type=template&id=53617cb9"
import script from "./RestaurantOrderItem.vue?vue&type=script&lang=js"
export * from "./RestaurantOrderItem.vue?vue&type=script&lang=js"

import "./RestaurantOrderItem.vue?vue&type=style&index=0&id=53617cb9&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__